import { FunctionComponent } from 'react'
import { Switch } from 'react-router-dom'

import Route from '../../../shared/routes/Route'
import { ListCaminhaoFactory } from '../factories/List'
import { RegisterCaminhaoFactory } from '../factories/Register'
import { CaminhaoProvider } from '../hooks/useCaminhao'
import CaminhaoRoutes from '../utils/CaminhaoRoutes'

const CaminhoesRoutes: FunctionComponent = () => {
  return (
    <Switch>
      <>
        <CaminhaoProvider>
          <Route
            path="/caminhoes/register"
            isPrivate
            exact
            component={RegisterCaminhaoFactory}
          />
        </CaminhaoProvider>
        <Route
          path={CaminhaoRoutes.LIST}
          isPrivate
          exact
          component={ListCaminhaoFactory}
        />
      </>
    </Switch>
  )
}

export default CaminhoesRoutes
